<template>
  <div class="operation-dialog">
    <md-popup
      v-model="dialogVisible"
      :mask-closable="false"
      @hide="hideDialog"
    >
      <div class="text">
        {{ title }}
      </div>
      <div class="operation-button">
        <a role="button" class="cancel" @click="hideDialog">{{ cancelText }}</a>
        <a role="button" class="confirm" @click="$emit('confirm')">{{ confirmText }}</a>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Popup } from 'mand-mobile'

import dialogMixins from '@/mixins/dialog'

export default {
  name: 'DialogLightTip',
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
  },
  mixins: [dialogMixins],
}
</script>

<style scoped lang="stylus">
.operation-dialog /deep/ {
  .md-popup-box {
    width: 90%;
    padding: 20px 20px 10px;
    background-color: #fff;
    border-radius: 6px;
  }
  .text {
    text-align: center;
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 1.25em;
    font-weight: bold;
  }
  .operation-button {
    display: flex;
    justify-content: space-around;
    a {
      display: block;
      padding: 10px 20px;
    }
  }
}
</style>
